var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClass(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6729_34282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33317 14.668V12.0013C9.33317 11.6477 9.19269 11.3085 8.94265 11.0585C8.6926 10.8084 8.35346 10.668 7.99984 10.668C7.64622 10.668 7.30708 10.8084 7.05703 11.0585C6.80698 11.3085 6.6665 11.6477 6.6665 12.0013V14.668",
    stroke: "#5E72E4",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 6.66797L14.2982 7.8173C14.4089 7.87263 14.502 7.95769 14.5671 8.06295C14.6322 8.16822 14.6668 8.28953 14.6668 8.4133V13.3346C14.6668 13.6883 14.5264 14.0274 14.2763 14.2774C14.0263 14.5275 13.6871 14.668 13.3335 14.668H2.66683C2.31321 14.668 1.97407 14.5275 1.72402 14.2774C1.47397 14.0274 1.3335 13.6883 1.3335 13.3346V8.4133C1.33356 8.28953 1.36808 8.16822 1.4332 8.06295C1.49831 7.95769 1.59144 7.87263 1.70216 7.8173L4.00016 6.66797",
    stroke: "#5E72E4",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.33203V14.6654",
    stroke: "#5E72E4",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 4.00148L7.40384 1.63281C7.5889 1.54033 7.79295 1.49219 7.99984 1.49219C8.20672 1.49219 8.41077 1.54033 8.59584 1.63281L13.3332 4.00148",
    stroke: "#5E72E4",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 3.33203V14.6654",
    stroke: "#5E72E4",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 7.33464C8.73622 7.33464 9.33317 6.73768 9.33317 6.0013C9.33317 5.26492 8.73622 4.66797 7.99984 4.66797C7.26346 4.66797 6.6665 5.26492 6.6665 6.0013C6.6665 6.73768 7.26346 7.33464 7.99984 7.33464Z",
    stroke: "#5E72E4",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6729_34282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/class.994d0a5d49afdba61d36147dd95e6e4e.svg";
export { ForwardRef as ReactComponent };